<template>
  <div class="yh_detail_bd">
    <p class="crumbs">
      <span>您的位置 : 
			<router-link to="/Index">首页</router-link> > 
      		<span @click="$router.back(-1)" class="pointer">社科成果库</span> > 
      <a>大事记文档</a></span>
    </p>
    <div class="details_main_box">
    	<h3 class="title_ txt_center">{{title}}</h3>
      <section class="book_txt">
        {{artical.d}}
      </section>
    </div>
  </div>
</template>

<script>
export default { 
  data () {
    return {
      artical: {},
      title: "2016.10.29-30中国梦：协调发展与全面建设小康社会学术前沿论坛",
    } 
  },
  methods: {
    to_read_fn() {
      this.$router.push({path:'/readOnLine', query: {id: this.artical.id}});
    }
  },
  mounted() {
    this.artical = require("../../static/json/detail.json");
    // this.$api.axios_memorabilia(this.$route.query.id).then(res => {
    //     this.artical = res.data;  
    //     console.log(123, this.artical)
    // })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	 @import url("../assets/css/details");
	
  .book_txt{
  	width: 960px;
    height: auto;
    overflow: hidden;
    background: none;
    margin-right: 5px;
    padding: 20px;
    margin-bottom: 30px;
  }
  .mid{
  	margin: 10px auto 0;
  	width: 500px;
  }
  .title_{
  	line-height: 20px;
  	height: 20px;
  	margin: 0 auto 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/memorabilia.vue